import { render, staticRenderFns } from "./SkipReasonsCard.vue?vue&type=template&id=309a9c70&"
import script from "./SkipReasonsCard.vue?vue&type=script&lang=js&"
export * from "./SkipReasonsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports